import { Component, OnInit } from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import { PagedContactTypeResponse } from '../../../core/models/contact-type.model'
import { EmployeeRoleCreateComponent } from '../../../features/employee/employee-role-create/employee-role-create.component'
import { MatButton } from '@angular/material/button'
import { SupplierService } from '../../../core/services/person/supplier/supplier.service'
import { SupplierCreateComponent } from '../../../features/person/supplier/supplier-create/supplier-create.component'
import { SupplierEditComponent } from '../../../features/person/supplier/supplier-edit/supplier-edit.component'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'
import { FormClientSearchComponent } from '../../../shared/components/form-client-search/form-search.component'
import { responseDefaultForm } from '../../../shared/utils/utils'
import { FormSupplierSearchComponent } from '../../../shared/components/form-supplier-search/form-supplier-search.component'
import { DialogLoadingComponent } from '../../../shared/components/dialog-loading/dialog-loading.component'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { SupplierConvertClientComponent } from '../../../features/person/supplier/supplier-convert-client/supplier-convert-client.component'
import { ClientService } from '../../../core/services/customer/client/client.service'
import { ResponseRequestModel } from '../../../core/models/response.model'

@Component({
  selector: 'supplier',
  imports: [
    TableListComponent,
    EmployeeRoleCreateComponent,
    MatButton,
    MatPaginatorModule,
    FormClientSearchComponent,
    MatProgressBar,
    FormSupplierSearchComponent,
  ],
  templateUrl: './supplier.component.html',
  styleUrl: './supplier.component.scss',
  providers: [SupplierService, AuthService, ClientService],
  standalone: true,
})
export class SupplierComponent implements OnInit {
  constructor(
    private supplierService: SupplierService,
    private clientService: ClientService,
    private authService: AuthService,
    private snackbar: SnackbarCustomService,
    private dialog: MatDialog,
  ) {}

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false

  columns: any[] = [
    // { keyColumn: 'code', key: 'id', description: 'Código' },
    {
      keyColumn: 'name',
      key: 'nomeFantasia',
      description: 'Nome',
    },
    {
      keyColumn: 'corporateName',
      key: 'razaoSocial',
      description: 'Razão Social',
    },
    {
      keyColumn: 'cnpj',
      key: 'cnpj',
      description: 'Cnpj',
    },
    {
      keyColumn: 'city',
      key: 'cidade',
      description: 'Cidade',
    },
    {
      keyColumn: 'state',
      key: 'estado',
      description: 'Estado',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false, convertToClient: false },
      description: 'Ações',
    },
  ]

  listSearch: any = [
    {
      id: 'nomeFantasia',
      description: 'Nome Fantasia',
      type: 'string',
      visible: true,
    },
    // { id: 'cpf', description: 'CPF', type: 'string', visible: true },
    {
      id: 'razaoSocial',
      description: 'Razão Social',
      type: 'string',
      visible: true,
    },
    { id: 'cnpj', description: 'Cnpj', type: 'string', visible: true },
    {
      id: 'inscricaoEstadual',
      description: 'Insc. Estadual',
      type: 'string',
      visible: false,
    },
    {
      id: 'cidade',
      description: 'Cidade',
      type: 'string',
      visible: true,
    },
    {
      id: 'estado',
      description: 'Estado',
      type: 'string',
      visible: true,
    },
    {
      id: 'inscricaoMunicipal',
      description: 'Insc. Munucipal',
      type: 'string',
      visible: false,
    },
  ]
  inputSearch: any = { type: '', search: '' }
  searchForm: any = { search: false, model: {} }

  screen = 'fornecedor'

  // pessoa_id de quem ja tem o papel de cliente, para desabilitar o "Virar cliente".
  clientPersonIds = new Set<number>()

  ngOnInit() {
    this.checkColumnAction()
    this.getClientPersonIds()
    this.getListItems()
  }

  getClientPersonIds() {
    this.clientService.listAllClient().subscribe({
      next: (response: ResponseRequestModel) => {
        const list = Array.isArray(response?.data) ? response.data : []
        this.clientPersonIds = new Set<number>(
          list.map((ele: any) => ele.pessoaId),
        )
        this.applyRoleFlags()
      },
      // Sem permissao na rota de cliente o conjunto fica vazio e o botao segue habilitado:
      // quem tentar converter uma empresa que ja e cliente recebe o 409 do back.
      error: () => {},
    })
  }

  applyRoleFlags() {
    for (const item of this.itemsList) {
      item.jaEhCliente = this.clientPersonIds.has(item.pessoaId)
    }
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: false,
        active: true,
        convertToClient: true,
        // delete: this.checkPermission('deletar'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  // search(event: any) {
  //   let search = event
  //   this.page = 1
  //   if (search) {
  //     this.searchForm.descricao = search
  //     this.searchListItems()
  //   } else {
  //     this.getListItems()
  //   }
  // }

  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }

  createModel(element: any) {
    const model: any = {
      inscMunicipal: '',
      inscEstadual: '',
      ativo: element.active,
    }

    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1
    this.uploadList()
  }

  // uploadList(type: string = '') {
  //   if (type == 'new') {
  //     this.searchForm = new SearchContactTypeModel()
  //   }
  //   if (this.searchForm.descricao) {
  //     this.searchListItems()
  //   } else {
  //     this.getListItems()
  //   }
  // }

  uploadList(type: 'new' | '' = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
    this.applyRoleFlags()
  }

  getListItems() {
    this.loading = true
    this.supplierService
      .listPagedSupplierLegal(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true
    this.supplierService
      .searchPagedSupplierLegal(this.page, this.rows, this.searchForm.model)
      // .searchPagedSupplierLegal(this.page, this.rows, this.searchForm)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  newEmployee() {
    const dialogRef = this.dialog.open(SupplierCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })
    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      this.uploadList()
    })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(SupplierEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { item },
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      this.uploadList()
    })
  }

  convertToClientItem(item: any) {
    const dialogRef = this.dialog.open(SupplierConvertClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '90vw',
      width: '100%',
      maxHeight: '90vh',
      data: { item: item },
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.getClientPersonIds()
        this.uploadList()
      }
    })
  }

  activeItem(item: any) {
    const dialogRef = this.dialog.open(DialogLoadingComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      width: '400',
      data: {
        message: `Aguarde, ${item.ativo == 'S' ? 'desativando' : 'ativando'} fornecedor.`,
        loading: true,
      },
    })
    const componentInstance = dialogRef.componentInstance
    this.supplierService
      .toggleSupplier({
        id: item.id,
        ativo: item.ativo.toLowerCase() == 's' ? 'N' : 'S',
      })
      .subscribe({
        next: (response: any) => {
          componentInstance.data.loading = false
          this.uploadList()
          this.snackbar.success(response.message)
          dialogRef.close()
        },
        error: (err: PagedContactTypeResponse) => {
          this.loading = false
          dialogRef.close()
        },
        complete: () => {
          this.uploadList()
          dialogRef.close()
          this.loading = false
        },
      })
  }

  deleteItem(item: any) {
  }
}
